/**
 * CookieBanner — PECR-compliant cookie consent notice.
 *
 * Essential cookies (authentication, session) do not require consent.
 * Any optional/analytics cookies must be declined by default until accepted.
 * Consent choice stored in localStorage so it persists across page loads.
 */
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'osabea_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() })); } catch {}
    setVisible(false);
  };

  const decline = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, date: new Date().toISOString() })); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9998,
        background: '#17324D',
        color: '#fff',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap',
        boxShadow: '0 -2px 16px rgba(0,0,0,0.18)',
        fontFamily: "'Inter', sans-serif",
        fontSize: '13px',
      }}
    >
      <p style={{ margin: 0, flex: '1 1 320px', lineHeight: '1.5', color: 'rgba(255,255,255,0.85)' }}>
        We use <strong style={{ color: '#fff' }}>essential cookies</strong> to keep the site working and keep you signed in.
        We only set optional analytics cookies with your consent.{' '}
        <Link
          to="/privacy"
          style={{ color: '#7fb3d3', textDecoration: 'underline', fontWeight: '500' }}
        >
          Privacy Policy
        </Link>
      </p>
      <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.35)',
            color: 'rgba(255,255,255,0.8)',
            borderRadius: '8px',
            padding: '8px 16px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
          }}
        >
          Essential only
        </button>
        <button
          onClick={accept}
          style={{
            background: '#0F5C5E',
            border: 'none',
            color: '#fff',
            borderRadius: '8px',
            padding: '8px 20px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '600',
          }}
        >
          Accept all
        </button>
      </div>
    </div>
  );
}
